import React from 'react';
import Context from "../Utilities";

const Fragment = window.wp.element.Fragment;

function Question3() {
    return (

        <Context.Consumer>
            {({ toggleApproval, approval, type }) => {
                return (
                    <Fragment>
                        <div id="question3" class="questions">
                            <div class="question"><p>And what’s your overall view of Trump?</p></div>
                            <div class="image">
                                <img src="https://assets.pewresearch.org/interactives/politics/2019/dinner-party/Path_none/Path_none.png" alt="Illustration of four dinner guests sitting at a table." id="q3img" />
                            </div>

                            <div class="options">
                                <button class="ui button" id="Disapprove" onClick={e => toggleApproval(e)}>
                                    I <strong>disapprove</strong> of Donald Trump
                                </button>
                                <button class="ui button" id="Approve" onClick={e => toggleApproval(e)}>
                                    I <strong>approve</strong> of Donald Trump
                                </button>
                            </div>
                        </div>
                    </Fragment>
                );
            }}
        </Context.Consumer>

    );
}

export default Question3;